var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeepLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.663,
    height: 13.552,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "carnet (1)",
    d: "M13.827 1.224H9.562a1.836 1.836 0 0 0-3.461 0H1.836A1.838 1.838 0 0 0 0 3.059v8.657a1.838 1.838 0 0 0 1.836 1.835h11.993a1.838 1.838 0 0 0 1.834-1.835V3.059a1.838 1.838 0 0 0-1.836-1.835Zm-6 0a.612.612 0 1 1-.612.612.613.613 0 0 1 .616-.612Zm6.608 10.493a.613.613 0 0 1-.611.612H1.836a.613.613 0 0 1-.612-.612V3.059a.613.613 0 0 1 .612-.612H6.1a1.835 1.835 0 0 0 3.461 0h4.266a.613.613 0 0 1 .612.612Zm-4.8-5.782h3.61v1.224H9.636Zm0 2.478h3.61v1.224H9.636ZM7.044 8a1.927 1.927 0 1 0-3.117.025 3.06 3.06 0 0 0-1.479 2.618h1.223a1.836 1.836 0 0 1 3.671 0h1.224A3.061 3.061 0 0 0 7.044 8ZM5.476 6.18a.7.7 0 1 1-.7.7.7.7 0 0 1 .7-.7Z",
    fill: "#185edf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepLinkIcon);
export default __webpack_public_path__ + "static/media/deepLink_Icon.67e9bcde3e098beeaaabc1d88c0622a6.svg";
export { ForwardRef as ReactComponent };